<script>
  import options from './SchemaMarkupCheckbox.options'
  export default options
</script>

<template>
  <div class="kb-checkbox" :class="{ 'kb-checkbox--disabled': disabled }">
    <label class="kb-checkbox__label">
      <input
        class="kb-checkbox__input"
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        @change="onChange"
      />
      <span class="kb-checkbox__text">{{ label }}</span>
    </label>
  </div>
</template>
